module.exports = __webpack_public_path__ + "img/mickey86.9d616370.jpg";